import React, { useCallback } from 'react';
import { useMediaQuery } from 'react-responsive';
import PropTypes from 'prop-types';

import Input from 'components/bronson/Input';
import RadioButton from 'components/bronson/RadioButton';

import {
    formatNumber,
    parseDecimal,
} from 'js/components/shared/vehicleFunctions';

import { vehicleTypes } from 'components/rentingRedRac/types';

const InitialPage = ({ t, values, renderError, setFieldValue, vehicle }) => {
    const isMobile = useMediaQuery({
        maxDeviceWidth: 600,
    });

    const renderInput = useCallback(
        (key, label, type, classes, decimal, props) => {
            return (
                <div className={`u-mb ${classes || ''}`}>
                    <Input
                        options={{
                            id: `${key}-input`,
                            name: key,
                            type,
                            event: true,
                            label,
                        }}
                        value={
                            decimal
                                ? formatNumber(
                                      values[key]
                                          ?.toString()
                                          ?.replaceAll('.', '')
                                  )
                                : values[key]
                        }
                        onChange={({ target: { name, value } }) => {
                            if (decimal) {
                                if (!value) setFieldValue(name, value);
                                setFieldValue(name, parseDecimal(value));
                            } else {
                                setFieldValue(name, value);
                            }
                        }}
                        {...props}
                    />
                    {renderError(key)}
                </div>
            );
        },
        [renderError, setFieldValue, values]
    );

    return (
        <>
            <h5 className="u-mb-large">{t.getTraduction('FillData')}</h5>
            <div
                className={`${
                    isMobile ? 'u-1/1' : 'u-1/2 u-inline-flex-item u-pr'
                } `}
            >
                <div className={`u-mb`} style={{ flexDirection: 'column' }}>
                    <p>{t.getTraduction('MinimumSellingImport')}</p>
                    <p className="u-text-bold">
                        {formatNumber(vehicle?.MinimumPrice.toFixed(2))}€
                    </p>
                </div>
                <div className={`u-mb`}>
                    <RadioButton
                        value={values.paymentMethod}
                        options={{
                            id: 'payment-input',
                            name: 'payment-input',
                            block: true,
                            text: t.getTraduction('PaymentMethod'),
                            showLabel: true,
                            values: [
                                {
                                    text: t.getTraduction('Cash'),
                                    value: 'C',
                                },
                                {
                                    text: t.getTraduction('VWFSFinancing'),
                                    value: 'F',
                                },
                            ],
                        }}
                        onChange={value =>
                            setFieldValue('paymentMethod', value)
                        }
                    />
                </div>
                {isMobile && values.paymentMethod === 'F' && (
                    <>
                        {renderInput(
                            'baseAmount',
                            t.getTraduction('EntryAmount'),
                            'text',
                            '',
                            true
                        )}
                        {renderInput(
                            'financialAmount',
                            t.getTraduction('FinancialAmount'),
                            'text',
                            '',
                            true
                        )}
                    </>
                )}
            </div>
            <div
                className={`${
                    isMobile ? 'u-1/1' : 'u-1/2 u-inline-flex-item u-pl'
                } `}
            >
                {renderInput('km', t.getTraduction('Kms'), 'text', '', false, {
                    value: formatNumber(values.km),
                    onChange: ({ target: { name, value } }) => {
                        if (
                            value.length > 10 ||
                            value.match(/[^\d.]/) ||
                            value.match(/^[0][0]/)
                        )
                            return;
                        setFieldValue(name, value.replaceAll('.', ''));
                    },
                })}
                {renderInput(
                    'amount',
                    t.getTraduction('SellingImport'),
                    'text',
                    '',
                    true
                )}
                {renderInput(
                    'documentId',
                    `${t.getTraduction(
                        'IdentificationDocuments'
                    )} ${t.getTraduction('Comprador')}`,
                    'text'
                )}
            </div>
            <div className={`u-1/1 u-flex u-flex-column u-flex-start`}>
                {!isMobile && values.paymentMethod === 'F' && (
                    <>
                        {renderInput(
                            'baseAmount',
                            t.getTraduction('EntryAmount'),
                            'text',
                            'u-1/2 u-pr',
                            true
                        )}
                        {renderInput(
                            'financialAmount',
                            t.getTraduction('FinancialAmount'),
                            'text',
                            'u-1/2 u-pr',
                            true
                        )}
                    </>
                )}
            </div>
        </>
    );
};

InitialPage.propTypes = {
    t: PropTypes.shape({
        getTraduction: PropTypes.func.isRequired,
    }),
    values: PropTypes.object.isRequired,
    renderError: PropTypes.func.isRequired,
    setFieldValue: PropTypes.func.isRequired,
    vehicle: vehicleTypes,
};

export default InitialPage;
